<form name="form" *ngIf="forgotVisible" (ngSubmit)="send($event,f , f.form.valid, 'forgotModal');" #f="ngForm" novalidate>
  <div class="modal fade" data-backdrop="static" data-keyboard="false" id="forgotModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1 boxRadius">
        <div class="modal-body pt-0">
          <button type="button" class="close videoclose outlinee" data-dismiss="modal" aria-label="Close" (click)="closeForgotModal(f)">
              <div _ngcontent-c5="" class="float-right mr-1 mt-1"><img _ngcontent-c5="" src="assets/images/editchart-close.svg" width="20"></div>
          </button>
          <br/>
          <div class="service-modal mt-0 mb-0 borderBox">
            <h1 class="text-center forghead semi-bold mt-3">Forgot your password?</h1>
            <div class="bdy-sec">
                <div class="form-group float-label-control">
                    <input type="text" class="form-control inputshadow fntsize" id="email" name="email" (keyup)="hideInvalidText()" [(ngModel)]="userObj.emailId" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                      required email 
                      />
                      <label for="email" style="font-size: 20px !important">Enter email address</label>
                    <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                      <div class="posabs boxcolour forgerr" *ngIf="email.errors.required">Email is required</div>
                    </div>
                    <div [hidden]="email.valid || email.pristine || !email.errors.pattern" class="">
                      <div class="posabs alertMsg boxcolour forgerr">Please enter a valid email</div>
                    </div>
                    <div class="boxcolour text-center forgerr" *ngIf="invalidEmail">Your email does not exist in my records.<br>
                        Wanna try another one?</div>
                  </div>
              <div class="form-group float-label-control text-center mb-0">
                <!-- <button class="btn mr-2 ml-2 col-12 resetbtn font-weight-bold" data-toggle="modal" data-target="#resetModal" [disabled]="!f.form.valid">RESET PASSWORD</button> -->
                <button class="btn mr-2 ml-2 col-12 resetbtn font-weight-bold-calibre">RESET PASSWORD</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="resetModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1">
        <div class="modal-body">
          <button type="button" class="close videoclose outlinee" data-dismiss="modal" aria-label="Close" (click)="closeResetModal()">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="service-modal">
            <div class="bdy-sec">
              <div>
                <p class="sb-ttl font-weight-normal-calibre resettxt text-center">Reset password link has been sent to<br>
                <font class="text-center semi-bold">{{enteredEmail | emailMask}}</font></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner></ngx-spinner>